<nav class="navbar navbar-light bg-light header">
  <a class="navbar-brand" routerLink="/">
    <!-- <img class="img-fluid" src="assets/images/logo_cns_branco.png" /> 
    <img class="img-fluid" src="assets/images/logo_cns_v2_transp.png" />-->
    <img class="img-logo" src="assets/images/logoheadertransp1.png" />
  </a>

  <div class="col-3 align-self-end dados" *ngIf="dadosCertificado && registroValido">
    <div class="grauSigilo">
      <span title="#EXTERNO.CONFIDENCIAL">#EXTERNO.CONFIDENCIAL</span>
    </div>
    <b>Certificado logado:</b><br />
    <b>Nome:</b> {{ dadosCertificado.razaoSocial }}<br />
    <div *ngIf="dadosRegistro && !isInscricaoPF">
      <b>{{ labelTipoInscricao }}: {{ inscricaoMascara }} </b>
      <b> / CPF:</b> {{ dadosCertificado.cpfResponsavel | cpf }} <br />
      <b>Responsável:</b> {{ dadosCertificado.responsavel !== null ? dadosCertificado.responsavel :
      dadosCertificado.razaoSocial }}<br />
    </div>

    <div *ngIf="dadosRegistro && isInscricaoPF">
      <b>{{ labelTipoInscricao }}: {{ inscricaoMascara }} </b>
    </div>

    <div *ngIf="dadosRegistro && dadosRegistro.de_perfil">
      <b>Perfil:</b> {{ dadosRegistro.de_perfil }}
    </div>
  </div>
</nav>
<div class="header" align="right">
  <button mat-button class="dados" (click)="redirecionaCnsPortal()">Voltar</button>
</div>
<div class="barra"></div>